import { gql } from '@apollo/client'

const qmrsGroupedByDfmCategoryQuery = gql`
    query qmrsGroupedByDfmCategory($quoteId: UUID, $orderId: String) {
        qmrsGroupedByDfmCategory(quoteId: $quoteId, orderId: $orderId) {
            category
            qmrs {
                id
                fileName
                version
                attachmentLink {
                    id
                    quoteAttachmentRevision {
                        id
                        attachment {
                            id
                            fileName
                        }
                    }
                }
                partRevision {
                    id
                    thumbnailUri
                }
                dfmFeedback {
                    id
                    isPublished
                }
            }
        }
    }
`

export default qmrsGroupedByDfmCategoryQuery
